<template>
    <v-form ref="p2Form" v-model="p2Form" lazy-validation>
        <v-container>
            <v-card class="UserGridlist" flat>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-form ref="tableForm" v-model="tableForm" lazy-validation>
                                <ryou-table ref="ryouTable" :rowKey="rowKey" :headers="headers"
                                            :queryParams="queryParam" :url="url" :businessKey="businessKey" :dummy="false"
                                            :needSearch="true" :height="height">
                                    <v-row slot="filterContainer">
                                        <v-col cols="1"></v-col>
                                        <v-col cols="4">
                                            <v-row class="pa-6">
                                                <ryou-input v-model="idFilterValue" :value="idFilterValue"
                                                            :label="'社員番号'">
                                                </ryou-input>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="4" class="UserAddBtn">
                                            <ryou-blue-btn :label="'新規追加'" :handlerClick="handleUserAdd">
                                            </ryou-blue-btn>
                                        </v-col>
                                    </v-row>
                                </ryou-table>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row class="fileAndBtn" v-show="showbtn">
                <v-col>
                    <v-file-input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                  label="利用者一括登録ファイル" v-model="chosenFile" :rules="inputRulesFile" truncate-length="55">
                    </v-file-input>
                </v-col>
                <v-col style="padding-top: 25px">
                    <ryou-black-btn :label="'ファイル入力'" :handlerClick="importFile" :iconCls="'mdi-file-upload'">
                    </ryou-black-btn>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
            <DormitoryUserDetailDialog ref="modalDialog" @closeDialog="closeDialog" :loadFlag="isload">
            </DormitoryUserDetailDialog>
            <BulkRegistrationErrorDialog ref="errorDialog">
            </BulkRegistrationErrorDialog>
        </v-container>
    </v-form>
</template>

<script>
    import RyouInput from "@/components/formInput/RyouInput.vue";
    import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    import RyouTable from "@/components/table/RyouTable.vue";
    import { RyouTableMixins } from "@/mixins/RyouTableMixins";
    import DormitoryUserDetailDialog from "./modules/DormitoryUserDetailDialog.vue";
    import BulkRegistrationErrorDialog from "./modules/BulkRegistrationErrorDialog.vue";

    import { postUploadRequest } from "@/utils/api";
    import { getRequest } from "@/utils/api";
    import { putRequest } from "@/utils/api";

    export default {
        name: "DormitoryUserList",
        mixins: [RyouTableMixins],
        components: {
            RyouInput,
            RyouBlueBtn,
            RyouBlackBtn,
            DormitoryUserDetailDialog,
            RyouTable,
            BulkRegistrationErrorDialog
        },
        mounted() {
            this.inputRulesFile.push(this.GlobalRules.required);
            this.$refs.ryouTable.$on("doHandleBtn", this.updateDeleBtn);
            this.$refs.ryouTable.$on("doLinkEdit", this.linkEdit);
        },
        data() {
            return {
                p2Form: true,
                inputRulesFile: [],
                valid: true,
                search: "",
                rowKey: "rowIndex",
                businessKey: "user_id",
                tableForm: true,
                idFilterValue: "",
                chosenFile: null,
                height: 578,
                isload: false,
                headers: [
                    {
                        text: "仮削除",
                        value: "sakujoBtn",
                        type: "btn",
                        width: "6%",
                        sortable: false,
                        groupable: false,
                    },
                    {
                        text: "利用者区分",
                        value: "user_class_name",
                        width: "10%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "社員番号",
                        value: "user_id",
                        width: "8%",
                        sortable: true,
                        groupable: false,
                        filter: this.idFilter,
                    },
                    {
                        text: "氏名",
                        value: "user_name",
                        type: "link",
                        width: "7%",
                        sortable: false,
                        groupable: false,
                    },
                    {
                        text: "職務名称",
                        value: "job_title",
                        width: "8%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "部署",
                        value: "affiliation",
                        width: "10%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "物件名",
                        value: "building_name",
                        width: "8%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "部屋番号",
                        value: "room_id",
                        width: "8%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "入居区分",
                        value: "dormitory_student_name",
                        width: "9%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "入居日",
                        value: "in_dormitory_date",
                        width: "7%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "退去予定日",
                        value: "out_dormitory_date",
                        width: "9%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "備考",
                        value: "remark",
                        width: "10%",
                        sortable: true,
                        groupable: false,
                    },
                ],
                url: {
                    originlist: "/dormitoryUser/dormitoryListGet/",
                    update: "/dormitoryUser/statusUpdate",
                },
            };
        },
        created() {
            this.initData();
        },
        methods: {
            initData() {
                var that = this;
                if (this.$route.params.user_id != null && this.$route.params.user_id != "") {
                    that.url.list = that.url.originlist + this.$route.params.user_id + "/" + 0 + "/" + "999";
                } else {
                    if (that.$store.getters.getUserClass == "1") {
                        that.url.list = that.url.originlist + " " + "/" + 0 + "/" + "999";
                    } else {
                        that.url.list = that.url.originlist + that.$store.getters.getUserId + "/" + 0 + "/" + that.$store.getters.getUserClass;
                    }
                }
            },
            //-->新規
            handleUserAdd() {
                this.isload = false;
                this.$refs.modalDialog.add();
            },
            //仮削除
            updateDeleBtn(item) {
                let params = {
                    loginUserId: this.$store.getters.getUserId,
                    user_id: item.user_id,
                    user_class: item.user_class,
                    out_dormitory_date: item.out_dormitory_date,
                    status: item.sakujoBtn,
                };
                this.putRequest(
                    this.url.update,
                    params,
                    this.$store.getters.getUserToken
                ).then((resp) => {
                    if (resp.success) {
                        this.$refs.ryouTable.loadData();
                    }
                });
                setTimeout(() => {
                    return;
                }, 100);
            },
            //氏名-->修正
            linkEdit(item) {
                this.isload = false;
                //this.$refs.modalDialog.edit(item.user_id);
                this.$refs.modalDialog.edit(item);
            },
            closeDialog() {
                this.$refs.ryouTable.loadData();
            },
            //一括登録
            importFile() {
                var valid = this.$refs.p2Form.validate();
                if (valid) {
                    let formData = new FormData();
                    formData.append("file", this.chosenFile);

                    postUploadRequest(
                        "/dormitoryUser/fileInsertUpdate?loginUserId=" +
                        this.$store.getters.getUserId,
                        formData,
                        this.$store.getters.getUserToken
                    ).then(async (resp) => {
                        if (resp.success) {
                            await this.createCognitoUsers();
                            this.$refs.ryouTable.loadData();
                        }
                    });      

                    
                }
                setTimeout(() => { }, 100);
            },
            //検索
            idFilter(value) {
                if (!this.idFilterValue) {
                    return true;
                } else {
                    console.log("error");
                }
                return value.toLowerCase().includes(this.idFilterValue.toLowerCase());
            },
            //cognito一括登録
            async createCognitoUsers() {
                var failureList = [];
                await getRequest("/api/Users", null, this.$store.getters.getUserToken)    //登録対象のユーザを取得
                    .then(async (resp) => {
                        for (var idx in resp) {
                            var user = resp[idx];
                            await this.$cognito
                                .signUp(user.user_id, user.mail_address, 1, user.password)       //cognito登録
                                .then((res) => {//eslint-disable-line
                                    //this.$toast.open({
                                    //    message: "cognito登録成功",
                                    //    type: "error"
                                    //});
                                    putRequest(                                                 //cognito成功時、DBのメアドを更新
                                        "/api/Users/" + user.user_id + "/" + user.mail_address,
                                        null,
                                        this.$store.getters.getUserToken
                                    ).then((resp) => {//eslint-disable-line
                                    })

                                })
                                .catch((err) => {       //eslint-disable-line                        
                                    //cognito失敗ユーザをリストに格納
                                    failureList.push(user.user_id)
                                })
                        }
                    });

               this.rollbackUserJohos(failureList)
            },

            //cognito登録失敗時（ロールバック）
            async rollbackUserJohos(failureList) {
                if (failureList.length > 0) {                       //cognito失敗ユーザが存在するなら、エラーダイアログを表示
                    var params = {
                        userList: failureList
                    }
                    await putRequest("dormitoryUser/userJohoDelete", params, this.$store.getters.getUserToken)
                        .then(resp => {
                            if (resp.success) {
                                this.$emit("ok");
                            }
                        })

                    var message = "【AWS】以下のユーザ登録に失敗しました。\n\n"
                    var i
                    for (i = 0; i < failureList.length; i++) {
                        message += failureList[i]+ "\n"
                    }
                    this.$refs.errorDialog.open("システム管理者にお問い合わせください。", message);

                }        
            }
        },
        computed: {
            showbtn() {
                if (this.$store.getters.getUserClass == "1") {
                    return true;
                } else {
                    return false;
                }
            },
        },

    };
</script>

<style scoped>
    .UserGridlist {
        outline: 1px solid rgb(147, 179, 204);
        padding-top: 30px;
        padding-bottom: 0px;
    }

    .UserAddBtn {
        padding-top: 30px;
        text-align: right;
    }

    .fileAndBtn {
        padding-top: 20px;
    }
</style>